module.exports = __webpack_public_path__ + "img/1558290299.da7a5085.jpg";